import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../config';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const base = getApiBaseUrl();
    try {
      const response = await axios.get(`${base}/api/auth/me`, {
        withCredentials: true
      });
      setUser(response.data);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (loginOrEmail, password) => {
    const base = getApiBaseUrl();
    const looksLikeEmail = typeof loginOrEmail === 'string' && loginOrEmail.includes('@');
    const body = looksLikeEmail
      ? { email: loginOrEmail.trim(), password }
      : { login: loginOrEmail.trim(), password };
    const response = await axios.post(`${base}/api/auth/login`, body,
      { withCredentials: true }
    );
    setUser(response.data);
    return response.data;
  };

  const register = async (email, password, name, username, role = 'analyst') => {
    const base = getApiBaseUrl();
    const response = await axios.post(`${base}/api/auth/register`,
      { email, password, name, username, role },
      { withCredentials: true }
    );
    setUser(response.data);
    return response.data;
  };

  const logout = async () => {
    const base = getApiBaseUrl();
    await axios.post(`${base}/api/auth/logout`, {}, { withCredentials: true });
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
